export const CardContainer = {
    width: '100%',
    maxHeight: '195px',
    borderRadius: '5px',
    flexWrap: 'wrap',
    fontSize: '10px',
    color: 'black',
    fontWeight: 500,
    background: '#ededed',
    cursor: 'pointer'
}

export const PaiEllipsis = {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer'
}

export const Ellipsis = {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}

export const CardTopo = {
    background: '#A8A4AB',
    minHeight: '17px',
    height: '17px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 4px',
    flexWrap: 'wrap',
    fontWeight: 700
    // borderTopRightRadius: '5px',
    // borderTopLeftRadius: '5px'
}

export const CardMiddle = {
    ...CardTopo,
    // border: '1px solid red',
    minHeight: '15px',
    height: '15px',
    background: '#FFFFF',
    fontWeight: 600
}

export const CardBottom = {
    ...CardTopo,
    fontWeight: 600,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
    // borderBottomRightRadius: '5px',
    // borderBottomLeftRadius: '5px'
}

export const GridCardEventoImgPerfil = {
    // border: '1px solid green',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto',
    padding: '2px'
}

export const CardEventoImgPerfil = {
    // border: '1px solid red',
    width: '100%',
    height: '100%',
    maxWidth: '37px',
    maxHeight: '28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
    // borderRadius: '3px'
}

export const CardEventoImgPerfilImg = {
    width: 'auto',
    height: 'auto',
    maxWidth: '37px',
    maxHeight: '28px',
    borderRadius: '3px'
}

export const spanAgrupamento = {
    fontWeight: 700
}
